import { msg } from "@lingui/core/macro";

export const maxPermitsPerPermitTypeRuleMessages = {
	name: msg({ message: "Max Permits Per Permit Type" }),
	description: msg({ message: "Limits the number of permits that can be active at a time on a Permit Type" }),
	errors: {
		limitReached: msg({ message: "Maximum Permits Reached. Allowed: {amount}" }),
	},
} as const;
